import { render, staticRenderFns } from "./SelectSellerAndManager.vue?vue&type=template&id=5c58f04e"
import script from "./SelectSellerAndManager.vue?vue&type=script&lang=js"
export * from "./SelectSellerAndManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports